import { render } from "./ProductStandard.vue?vue&type=template&id=6d18c4f6"
import script from "./ProductStandard.vue?vue&type=script&lang=js"
export * from "./ProductStandard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__